// ═══════════════════════════════════════════════════════════════════════════
// THE ARAB-NUBIAN BRIEF - Constants & Content Data
// ═══════════════════════════════════════════════════════════════════════════

export const SITE_CONFIG = {
  name: "The Arabian-Nubian Brief",
  tagline: "Mining Intelligence for the Arabian-Nubian Region",
  branding: {
    primary: "Brought to you by Ankh Resources",
    secondary: "Powered by Omniscan AI",
  },
  copyright: "Ankh Resources",
};

// Regional Navigation
export const REGIONAL_BRIEFS = [
  {
    id: "latam",
    name: "LATAM",
    fullName: "Latin America Brief",
    href: "#latam",
    color: "green",
  },
  {
    id: "ssa",
    name: "SSA",
    fullName: "Sub-Saharan Africa Brief",
    href: "#ssa",
    color: "red",
  },
  {
    id: "cea",
    name: "CEA",
    fullName: "Central/East Africa Brief",
    href: "#cea",
    color: "blue",
  },
  {
    id: "asia",
    name: "Asia",
    fullName: "Asia Brief",
    href: "#asia",
    color: "purple",
  },
  {
    id: "arab-nubian",
    name: "Arabian-Nubian",
    fullName: "Arabian-Nubian Brief",
    href: "#",
    color: "gold",
    active: true,
  },
];

// News Ticker Headlines
export const TICKER_HEADLINES = [
  "BREAKING: Major gold discovery reported in Eastern Sudan mining sector",
  "Egypt announces new mining sector reforms to attract foreign investment",
  "Saudi Arabia expands precious metals exploration program",
  "Ethiopian government approves three new mining licenses",
  "Gold prices surge amid Middle East geopolitical tensions",
  "Morocco's phosphate exports reach record highs in Q4",
  "UAE-backed consortium acquires stake in Sudanese gold operations",
  "Algeria opens bidding for rare earth mineral exploration",
];

// Content Categories
export const CONTENT_CATEGORIES = [
  {
    id: "gold",
    name: "Gold & Precious Metals",
    description: "Exploration, production updates, and reserve reports",
    icon: "Gem",
    color: "gold",
  },
  {
    id: "deals",
    name: "Deals & Investment",
    description: "M&A activity, joint ventures, and funding rounds",
    icon: "Handshake",
    color: "blue",
  },
  {
    id: "policy",
    name: "Policy & Infrastructure",
    description: "Regulatory changes and government initiatives",
    icon: "Scale",
    color: "ink",
  },
  {
    id: "operations",
    name: "Operations Updates",
    description: "Mine developments, expansions, and closures",
    icon: "HardHat",
    color: "orange",
  },
  {
    id: "markets",
    name: "Markets Analysis",
    description: "Price trends, demand forecasts, and trade flows",
    icon: "TrendingUp",
    color: "green",
  },
];

// Sample Articles for Content Showcase
export const SAMPLE_ARTICLES = [
  {
    id: 1,
    category: "gold",
    title: "Sudan's Hassai Gold Mine Reports 40% Production Increase",
    excerpt:
      "The flagship operation has implemented new extraction technologies, boosting quarterly output to 45,000 ounces.",
    date: "Jan 5, 2026",
    featured: true,
  },
  {
    id: 2,
    category: "deals",
    title: "Egyptian-Saudi JV Secures $200M for Red Sea Exploration",
    excerpt:
      "Strategic partnership targets untapped mineral deposits along the Eastern Desert corridor.",
    date: "Jan 4, 2026",
  },
  {
    id: 3,
    category: "policy",
    title: "Morocco Introduces Fast-Track Mining Permit Process",
    excerpt:
      "New regulatory framework reduces approval timelines from 18 months to 6 months for qualified operators.",
    date: "Jan 3, 2026",
  },
  {
    id: 4,
    category: "operations",
    title: "Algeria's Amesmessa Mine Begins Phase II Development",
    excerpt:
      "Expansion project will double processing capacity and create 500 new jobs in the region.",
    date: "Jan 2, 2026",
  },
  {
    id: 5,
    category: "markets",
    title: "Gold Demand Surges in MENA Region Amid Currency Volatility",
    excerpt:
      "Central banks increase reserves as regional investors seek safe-haven assets.",
    date: "Jan 1, 2026",
  },
];

// Value Propositions
export const VALUE_PROPOSITIONS = [
  {
    title: "Regional Expertise",
    description:
      "Deep coverage of Egypt, Sudan, Saudi Arabia, Ethiopia, Morocco, Algeria, and neighboring mining regions.",
    icon: "Globe",
  },
  {
    title: "Actionable Intelligence",
    description:
      "Investment signals, partnership opportunities, and regulatory changes that matter. Get the insights you need to make informed decisions.",
    icon: "Lightbulb",
  },
  {
    title: "Weekly Delivery",
    description:
      "Consistent weekly delivery to your inbox with curated insights. Never miss a critical development in the Arabian-Nubian mining sector.",
    icon: "Calendar",
  },
];

// Features
export const FEATURES = [
  {
    title: "Curated Intelligence",
    description:
      "Hand-picked stories from across the Arabian-Nubian mining landscape, filtered for relevance and impact. We cut through the noise so you don't have to.",
    icon: "Filter",
  },
  {
    title: "Data-Driven Insights",
    description:
      "Charts, tables, and visualizations that make complex market data accessible. Understand trends at a glance with our analytical deep-dives.",
    icon: "BarChart3",
  },
  {
    title: "Expert Commentary",
    description:
      "Analysis from regional specialists with decades of on-the-ground experience. Get perspectives you won't find anywhere else.",
    icon: "MessageSquare",
  },
  {
    title: "Deal Flow Tracking",
    description:
      "Comprehensive coverage of M&A activity, joint ventures, and investment rounds across the region. Stay ahead of the competition.",
    icon: "GitMerge",
  },
];

// FAQ Items
export const FAQ_ITEMS = [
  {
    question: "How often is The Arabian-Nubian Brief published?",
    answer:
      "The Brief is published weekly, delivered every week to your inbox. We also send breaking news alerts for major developments that can't wait.",
  },
  {
    question: "What regions does the newsletter cover?",
    answer:
      "Our primary focus is the Arabian-Nubian region, including Egypt, Sudan, Saudi Arabia, UAE, Ethiopia, Eritrea, Morocco, Algeria, Tunisia, and Libya. We also cover relevant developments from neighboring regions that impact Arabian-Nubian mining.",
  },
  {
    question: "How do I unsubscribe?",
    answer:
      "You can unsubscribe at any time by clicking the 'Unsubscribe' link at the bottom of any email, or by contacting our support team. We make it easy to leave (though we hope you'll stay!).",
  },
];
